import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const INGOT = "#bfc4cc";
const INGOT_DK = "#9097a0";
const INGOT_HI = "#dfe3ea";

function barUnit(cx: number, cy: number, cz: number, w: number, c: string, top: string): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(w, w * 0.34, w * 0.52), color: c, position: [cx, cy, cz] },
    { geometry: new THREE.BoxGeometry(w * 0.82, 0.008, w * 0.4), color: top, position: [cx, cy + w * 0.18, cz] },
  ];
}

export const ingotBundle = defineModel({
  id: "ingot-bundle",
  batchId: "characters",
  name: "Ingot bundle",
  tags: ["good", "cargo", "metal"],
  fits: ["carry"],
  summary: "A pair of stacked metal ingots -- a carriable good for an avatar's carry socket.",
  description:
    "Two trapezoidal ingot bars at held scale, ported from age-of-mcp's goods " +
    "(`ingot`). Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling refined metal.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => [
    ...barUnit(0, 0.03, 0.0, 0.12, INGOT, INGOT_HI),
    ...barUnit(0, 0.062, 0.0, 0.115, INGOT_DK, INGOT),
  ],
  animations: [],
});
